export function hasAnyAddressValue(watch: Function): boolean {
  const streetAddressValue = watch("streetAddress");
  const streetAddress2Value = watch("address2");
  const zipPostalValue = watch("zipPostal");
  const cityValue = watch("city");
  const stateProvValue = watch("stateProv");
  const countryValue = watch("country");

  return !!(
    streetAddressValue ||
    streetAddress2Value ||
    zipPostalValue ||
    cityValue ||
    stateProvValue ||
    countryValue
  );
}
